import React, { useEffect, useState } from 'react';
import { ArrowLong, Full } from '../../assets/img/svg/icons';
import { Autoplay, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';

const Galeria: React.FC<{ galeria?: Array<{ imagem: string }> }> = ({ galeria }) => {

    const [expandedImage, setExpandedImage] = useState<string | null>(null);
    const [expandedIndex, setExpandedIndex] = useState<number | null>(null);

    const handleImageClick = (image: string, index: number) => {
        setExpandedImage(image);
        setExpandedIndex(index);
    };

    const closeExpandedImage = () => {
        setExpandedImage(null);
        setExpandedIndex(null);
    };

    const handleSlideChange = (swiper: any) => {
        setExpandedIndex(swiper.realIndex);
    };

    useEffect(() => {
        if (!expandedImage) return;
    
        const handleKeyDown = (event: KeyboardEvent) => {
            const prevButton = document.querySelector<HTMLDivElement>('.swiper-prev-expand');
            const nextButton = document.querySelector<HTMLDivElement>('.swiper-next-expand');
    
            switch (event.key) {
                case 'ArrowRight':
                    nextButton?.click();
                    break;
                case 'ArrowLeft':
                    prevButton?.click();
                    break;
                case 'Escape':
                    closeExpandedImage();
                    break;
                default:
                    break;
            }
        };
    
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [expandedImage, closeExpandedImage]);

    const customGallery = galeria ? 
        Array.from({ length: Math.ceil(galeria.length / 8) }, (_, i) => galeria.slice(i * 8, i * 8 + 8)
    ) : [];

    return (
        <section className='mb-8 bg-[#EFF9FA] z-50 relative'>
            <div className="max-w-[1920px] mx-auto">
                <div className="mt-10">
                    <Swiper
                        loop
                        className="relative w-full"
                        modules={[Navigation, Autoplay]}
                        autoplay={{ delay: 4000 }}
                        slidesPerView={1}
                        slidesPerGroup={1}
                        navigation={{
                            prevEl: '.swiper-prev',
                            nextEl: '.swiper-next',
                        }}
                        breakpoints={{
                            767: { slidesPerView: 1 },
                        }}
                    >
                        {galeria && galeria.length > 0 &&
                            customGallery.map((grupo, index) => {
                                return (
                                    <SwiperSlide key={index} className='!w-full'>
                                        <div className={`grid grid-cols-2 md:grid-cols-4 w-full`}>
                                            {grupo.map((gallery, i) => (
                                                <div
                                                    key={i}
                                                    className="group relative after:content-[''] after:w-full after:h-full after:border-4 after:border-main-pink after:absolute after:left-0 after:top-0 after:opacity-0 after:transition-all after:duration-200 hover:after:opacity-100 cursor-pointer"
                                                    onClick={() => handleImageClick(gallery.imagem, index * 8 + i)}
                                                >
                                                <img
                                                    src={gallery.imagem}
                                                    alt="Imagem da galeria"
                                                    className="w-full h-32 md:h-56 2xl:h-64 object-cover grayscale-[100] transition-all duration-200 group-hover:grayscale-0"
                                                />
                                                <div className="absolute right-4 bottom-4 rounded-full h-12 w-12 bg-white/50 flex items-center justify-center opacity-0 group-hover:opacity-100">
                                                    <Full className="w-2/5 h-2/5 object-contain" />
                                                </div>
                                            </div>
                                            ))}
                                        </div>
                                    </SwiperSlide>
                                );
                            })
                        }

                        {galeria && galeria.length > 8 && (
                            <div className="swiper-prev z-40 absolute top-1/2 -translate-y-1/2 left-4 md:left-12 cursor-pointer group bg-main-pink w-10 h-10 rounded-full flex items-center justify-center transition-all duration-200 hover:bg-main-blue">
                                <ArrowLong className='-scale-x-100 w-1/2 h-1/2 object-contain' />
                            </div>
                        )}

                        {galeria && galeria.length > 8 && (
                            <div className="swiper-next z-40 absolute top-1/2 -translate-y-1/2 right-4 md:right-12 cursor-pointer group bg-main-pink w-10 h-10 rounded-full flex items-center justify-center transition-all duration-200 hover:bg-main-blue">
                                <ArrowLong className='w-1/2 h-1/2 object-contain' />
                            </div>
                        )}
                    </Swiper>
                </div>
            </div>

            {expandedImage !== null && expandedIndex !== null && (
                <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50">
                    <span className='absolute left-0 top-0 w-dvw h-dvh z-10' onClick={closeExpandedImage}></span>
                    
                    <div className="cursor-pointer w-10 h-10 z-30 bg-main-pink flex items-center justify-center absolute top-4 right-4 md:right-8 rounded-full text-2xl text-white transition-all duration-200 hover:bg-main-blue" onClick={closeExpandedImage}>
                        X
                    </div>
                    
                    <div className='absolute left-1/2 bottom-6 -translate-x-1/2 bg-main-pink text-white p-1 px-2 rounded-full text-sm text-center z-30'>
                        {(expandedIndex + 1).toString().padStart(2, '0')} / {galeria?.length}
                    </div>

                    <div className="max-w-full max-h-full z-20 pointer-events-none">
                        <Swiper
                            loop
                            className="relative"
                            modules={[Navigation]}
                            slidesPerView={1}
                            initialSlide={expandedIndex}
                            onSlideChange={handleSlideChange}
                            navigation={{
                                prevEl: '.swiper-prev-expand',
                                nextEl: '.swiper-next-expand',
                            }}
                        >
                            {galeria &&
                                galeria.map((gallery, index) => (
                                    <SwiperSlide key={index}>
                                        <div className="w-dvw h-dvh p-4 flex justify-center items-center">
                                            <img
                                                src={gallery.imagem}
                                                alt="Imagem Expandida"
                                                className="max-h-full max-w-full pointer-events-auto"
                                            />
                                        </div>
                                    </SwiperSlide>
                                ))}

                            <div className="swiper-prev-expand z-40 absolute top-1/2 -translate-y-1/2 left-6 md:left-12 cursor-pointer group bg-main-pink w-10 h-10 rounded-full flex items-center justify-center transition-all duration-200 hover:bg-main-blue pointer-events-auto">
                                <ArrowLong className='-scale-x-100 w-1/2 h-1/2 object-contain' />
                            </div>

                            <div className="swiper-next-expand z-40 absolute top-1/2 -translate-y-1/2 right-6 md:right-12 cursor-pointer group bg-main-pink w-10 h-10 rounded-full flex items-center justify-center transition-all duration-200 hover:bg-main-blue pointer-events-auto">
                                <ArrowLong className='w-1/2 h-1/2 object-contain' />
                            </div>
                        </Swiper>
                    </div>
                </div>
            )}
        </section>
    );
};

export default Galeria;
